export default {
  name: 'marking--atk',
  apiService: 'shoes',
  apiPath: '/admin/atk',

  enums: {
    docType: ['ATK_AGGREGATION', 'ATK_TRANSFORMATION', 'ATK_DISAGGREGATION'],
    transformationType: ['REMOVING', 'ADDING'],
  }
};